<script>
  /**
   * @type {Object} table list data
   */
  export let jsonData
  /**
   * @type {Array<jsonData>} - it consists of filtered json list. It displayed in list.
   */
  export let sortData
  /**
   * @type {Boolean} - controls the show or hide the FilterForm.
   */
  export let showFilterForm
  /**
   * @type {Boolean} - in DAC after filted this variable handle some conponents show and hidden state.
   */
  export let searched = false

  /**
   * @type {Array} secured types are shown for showing list
   */
  let checked = []

  /**
   * @description Function for filter the list
   */
  const filterList = () => {
    if (checked.length == 0) {
      sortData = jsonData.filter((json) => !json.emailList.length && !json.emailDomain && !json.passcode && !json.nda && !json.notice && !json.expireOn)
    } else if (checked.length == 1) {
      if (checked[0] != "emailList") sortData = jsonData.filter((json) => (checked[0] == "nda" ? json.nda || json.notice : json[checked[0]]))
      else sortData = jsonData.filter((json) => json.emailList.length || json.emailDomain)
    } else if (checked.length == 2) {
      if (checked[0] != "emailList") sortData = jsonData.filter((json) => (checked[0] == "nda" ? json.nda || json.notice : json[checked[0]]) && (checked[1] == "nda" ? json.nda || json.notice : json[checked[1]]))
      else sortData = jsonData.filter((json) => (json.emailList.length || json.emailDomain) && (checked[1] == "nda" ? json.nda || json.notice : json[checked[1]]))
    } else if (checked.length == 3) {
      if (checked[0] != "emailList") sortData = jsonData.filter((json) => json[checked[0]] && (json.nda || json.notice) && json[checked[2]])
      else sortData = jsonData.filter((json) => (json.emailList.length || json.emailDomain) && (checked[1] == "nda" ? json.nda || json.notice : json[checked[1]]) && (checked[2] == "nda" ? json.nda || json.notice : json[checked[2]]))
    } else if (checked.length == 4) {
      if (checked[0] != "emailList") sortData = jsonData.filter((json) => json[checked[0]] && json[checked[1]] && json[checked[2]] && json[checked[3]])
      else sortData = jsonData.filter((json) => (json.emailList.length || json.emailDomain) && json.passcode && (json.nda || json.notice) && json.expireOn)
    } else {
      return
    }
    searched = true
    showFilterForm = false
  }
</script>

<div class="absolute right-0 top-12 z-20 w-auto space-y-3 rounded-md border border-[#a0a1a580] bg-white px-6 pb-3 pt-6 shadow-md dark:bg-darkgray">
  <div>
    <div class="flex items-center gap-3 text-xl dark:text-white">
      <i class="fa-solid fa-filter-list" />
      <span class="text-lg font-semibold">Filter</span>
    </div>
    <p class="text-gray-200">You can filter the table list using below details.</p>
  </div>
  <div class="space-y-3 py-3">
    <div class="flex items-center gap-3">
      <input bind:group={checked} id="email" type="checkbox" value="emailList" class="h-4 w-4 cursor-pointer" />
      <label for="email" class="cursor-pointer text-sm text-gray-200">Secured by Email</label>
    </div>
    <div class="flex items-center gap-3">
      <input bind:group={checked} id="passcode" name="filter" value="passcode" type="checkbox" class="h-4 w-4 cursor-pointer" />
      <label for="passcode" class="cursor-pointer text-sm text-gray-200">Secured by Passcode</label>
    </div>
    <div class="flex items-center gap-3">
      <input bind:group={checked} id="url" type="checkbox" value="nda" class="h-4 w-4 cursor-pointer" />
      <label for="url" class="cursor-pointer text-sm text-gray-200">Secured by NDA / Notice</label>
    </div>
    <div class="flex items-center gap-3">
      <input bind:group={checked} id="expiry" type="checkbox" value="expireOn" class="h-4 w-4 cursor-pointer" />
      <label for="expiry" class="cursor-pointer text-sm text-gray-200">Secured by Expiry</label>
    </div>
  </div>
  <div class="flex justify-between gap-3 border-t border-[#a0a1a580] pt-3">
    <button
      on:click={() => {
        showFilterForm = false
      }}
      class="flex h-9 w-full cursor-pointer items-center justify-center px-2 text-base font-medium text-red-500 hover:text-red-600 focus:outline-none active:text-red-500 disabled:cursor-not-allowed disabled:text-red-300 lg:px-4"
    >
      <i class="fa-solid fa-xmark" />
      &nbsp;&nbsp;Cancel
    </button>
    <button on:click={filterList} type="button" class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-base font-medium text-green-500 hover:text-green-600 focus:outline-none active:text-green-500 disabled:cursor-not-allowed disabled:text-green-300 lg:px-4">
      <i class="fa-solid fa-check" />
      &nbsp;&nbsp;Apply
    </button>
  </div>
</div>
